export const propertyLabels: { [key: string]: { label: string; ordem?: number }; } = {


};

export const modalTitulo = "Endereço";
export const modalTexto = "Deseja remover este endereço?"
export const UrlBuscarPaginado = "Endereco/BuscarPaginado";
export const UrlEndereco = "Endereco";

export const propertyLabelsLoja: { [key: string]: { label: string; ordem?: number }; } = {
    razaoSocial: { label: "Loja", ordem: 1 },
    logradouro: { label: "Logradouro", ordem: 2 },
    numero: { label: "Número", ordem: 3 },
    cep: { label: "Cep", ordem: 4 },
    cidade: { label: "Cidade", ordem: 4 },
    estado: { label: "Estado", ordem: 5 }

};

export const propertyLabelsColaborador: { [key: string]: { label: string; ordem?: number }; } = {
    nomeColaborador: { label: "Nome", ordem: 1 },
    logradouro: { label: "Logradouro", ordem: 2 },
    numero: { label: "Número", ordem: 3 },
    cep: { label: "Cep", ordem: 4 },
    cidade: { label: "Cidade", ordem: 4 },
    estado: { label: "Estado", ordem: 5 }

};